export const validation = {
  methods: {
    mix_validateField (ev, rule) {
      let re
      const val = ev.key
      switch (rule) {
        case 'alpha':
          re = /[- a-zA-Z]/
          break
        case 'number':
          re = /[0-9.]/
          break
      }
      !re.test(val) && ev.preventDefault()
    }
  }
}
